// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/il1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/il2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/il3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./images/il4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./images/il5.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    height: 100% !important;
}
#root {
    overflow: hidden;
    font-family: 'Manrope', serif;
}
#root .auth {
    background: #4A444C;
}
 .white, .white a {
    color: #fff;
}
.auth-main {
  height: 100vh!important;
  overflow: hidden;
  position: relative;
}

.auth-main .il1 {
position: absolute;
left: 76.35%;
right: 0;
top: 0;
bottom: 71.2%;
width:214px;
height:214px;
background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), #D9D9D9;
border-radius: 24px;
}

.auth-main .il2 {
position: absolute;
left: 63.65%;
right: 25.52%;
top: 0;
bottom: 86.81%;
width:98px;
height:98px;
background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
border-radius: 24px;
}
.auth-main .il3 {
position: absolute;
left: 76.35%;
right: 0;
top: 71.2%;
bottom: 0;
width:214px;
height:214px;
background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
border-radius: 24px;
}
.auth-main .il4 {
position: absolute;
left: 25.52%;
right: 38.12%;
top: 0;
bottom: 0;
width:329px;
height:743px;
background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
border-radius: 24px;
}
.auth-main .il5 {
position: absolute;
left: 0.11%;
right: 76.24%;
top: 0;
bottom: 71.2%;
width:214px;
height:214px;
background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
border-radius: 24px;
}
.auth-main .title {
position: relative;
left: 0;
right: 12.82%;
top: 33.24%;
bottom: 30.42%;
font-style: normal;
font-weight: 800;
font-size: 88px;
line-height: 102%;
color: #FFFFFF;
}

.form {
    background: #fff;
    border-radius: 40px;
}
.form .inputs .btn-group input {
    padding-left: 55px;
    font-size: 1.5rem;
    margin: 20px 10px;
    width: 270px;
}
.form .inputs .btn-group .flag-container {
    margin-right: -35px;
}

.verify .inputs .btn-group input {
    width: 55px;
    padding-left: 14px;
    text-align: center;
}
.form .flag-icon {
   width: 32px;
   height: 32px;
   margin-right: -15px;
   }
@media all and (min-width: 1024px) {
    .verify .inputs .btn-group input {
        width: 69px;
        }
}`, "",{"version":3,"sources":["webpack://./src/auth.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;CACC;IACG,WAAW;AACf;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;AACA,kBAAkB;AAClB,YAAY;AACZ,QAAQ;AACR,MAAM;AACN,aAAa;AACb,WAAW;AACX,YAAY;AACZ,4DAA4C;AAC5C,mBAAmB;AACnB;;AAEA;AACA,kBAAkB;AAClB,YAAY;AACZ,aAAa;AACb,MAAM;AACN,cAAc;AACd,UAAU;AACV,WAAW;AACX,mDAAmC;AACnC,mBAAmB;AACnB;AACA;AACA,kBAAkB;AAClB,YAAY;AACZ,QAAQ;AACR,UAAU;AACV,SAAS;AACT,WAAW;AACX,YAAY;AACZ,mDAAmC;AACnC,mBAAmB;AACnB;AACA;AACA,kBAAkB;AAClB,YAAY;AACZ,aAAa;AACb,MAAM;AACN,SAAS;AACT,WAAW;AACX,YAAY;AACZ,mDAAmC;AACnC,mBAAmB;AACnB;AACA;AACA,kBAAkB;AAClB,WAAW;AACX,aAAa;AACb,MAAM;AACN,aAAa;AACb,WAAW;AACX,YAAY;AACZ,mDAAmC;AACnC,mBAAmB;AACnB;AACA;AACA,kBAAkB;AAClB,OAAO;AACP,aAAa;AACb,WAAW;AACX,cAAc;AACd,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,cAAc;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;AACA;GACG,WAAW;GACX,YAAY;GACZ,mBAAmB;GACnB;AACH;IACI;QACI,WAAW;QACX;AACR","sourcesContent":["html, body {\n    height: 100% !important;\n}\n#root {\n    overflow: hidden;\n    font-family: 'Manrope', serif;\n}\n#root .auth {\n    background: #4A444C;\n}\n .white, .white a {\n    color: #fff;\n}\n.auth-main {\n  height: 100vh!important;\n  overflow: hidden;\n  position: relative;\n}\n\n.auth-main .il1 {\nposition: absolute;\nleft: 76.35%;\nright: 0;\ntop: 0;\nbottom: 71.2%;\nwidth:214px;\nheight:214px;\nbackground: url('./images/il1.png'), #D9D9D9;\nborder-radius: 24px;\n}\n\n.auth-main .il2 {\nposition: absolute;\nleft: 63.65%;\nright: 25.52%;\ntop: 0;\nbottom: 86.81%;\nwidth:98px;\nheight:98px;\nbackground: url('./images/il2.png');\nborder-radius: 24px;\n}\n.auth-main .il3 {\nposition: absolute;\nleft: 76.35%;\nright: 0;\ntop: 71.2%;\nbottom: 0;\nwidth:214px;\nheight:214px;\nbackground: url('./images/il3.png');\nborder-radius: 24px;\n}\n.auth-main .il4 {\nposition: absolute;\nleft: 25.52%;\nright: 38.12%;\ntop: 0;\nbottom: 0;\nwidth:329px;\nheight:743px;\nbackground: url('./images/il4.png');\nborder-radius: 24px;\n}\n.auth-main .il5 {\nposition: absolute;\nleft: 0.11%;\nright: 76.24%;\ntop: 0;\nbottom: 71.2%;\nwidth:214px;\nheight:214px;\nbackground: url('./images/il5.png');\nborder-radius: 24px;\n}\n.auth-main .title {\nposition: relative;\nleft: 0;\nright: 12.82%;\ntop: 33.24%;\nbottom: 30.42%;\nfont-style: normal;\nfont-weight: 800;\nfont-size: 88px;\nline-height: 102%;\ncolor: #FFFFFF;\n}\n\n.form {\n    background: #fff;\n    border-radius: 40px;\n}\n.form .inputs .btn-group input {\n    padding-left: 55px;\n    font-size: 1.5rem;\n    margin: 20px 10px;\n    width: 270px;\n}\n.form .inputs .btn-group .flag-container {\n    margin-right: -35px;\n}\n\n.verify .inputs .btn-group input {\n    width: 55px;\n    padding-left: 14px;\n    text-align: center;\n}\n.form .flag-icon {\n   width: 32px;\n   height: 32px;\n   margin-right: -15px;\n   }\n@media all and (min-width: 1024px) {\n    .verify .inputs .btn-group input {\n        width: 69px;\n        }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
